module.exports = __webpack_public_path__ + "img/more_button.b2fc50ae.png";